import { FC, Fragment } from 'react'
import { Card, ScheduledItemCard } from 'components/Card'
import { BreadType } from 'types/bread'
import { StockType } from 'types/stock'
import { HorizontalLine } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getCategories } from 'reducks/category/selectors'
import { CategoryType } from 'types/category'
import { ScheduleType } from 'types/schedule'
import { OrderType } from 'types/checkout'
import { getOrders } from 'reducks/checkout/selectors'
import { useCheckoutItemsFromOrders } from 'hooks/checkout'
import { DayOfWeekType } from 'lib/daysOfWeek'

type Props = {
  breads: BreadType[]
  checkedOrderTypes: string[]
  currentTab: 'released' | 'unreleased'
  date: Date
  dayOfWeek: DayOfWeekType
  isAfterLastOrder: boolean
  isFuture: boolean
  isTemporaryClose: boolean
  dailySchedules: ScheduleType[]
  preorderSchedules: ScheduleType[]
  stocks: StockType[]
}

const ScheduledItemCardList: FC<Props> = (props) => {
  const {
    breads,
    checkedOrderTypes,
    currentTab,
    date,
    dayOfWeek,
    isAfterLastOrder,
    isFuture,
    isTemporaryClose,
    dailySchedules,
    preorderSchedules,
    stocks,
  } = props
  const categories: CategoryType[] = useSelector((state: State) => getCategories(state))
  const orders: OrderType[] = useSelector((state: State) => getOrders(state))
  const checkoutItems = useCheckoutItemsFromOrders(orders)

  return (
    <Card>
      {breads.map((bread, index) => {
        if (!bread.bread_ref) return
        const category = categories.find((category) => category.category_ref.id === bread.category.id)
        if (!category) return
        // 販売曜日を満たす schedule を優先するが、都度配信の場合は販売曜日に関係なく schedule を返却する
        const dailySchedule =
          dailySchedules.find(
            (schedule) => schedule.bread_ref.id === bread.bread_ref?.id && schedule.days_of_week.includes(dayOfWeek)
          ) ?? dailySchedules.find((schedule) => schedule.bread_ref.id === bread.bread_ref?.id)
        const preorderSchedule =
          preorderSchedules.find(
            (schedule) => schedule.bread_ref.id === bread.bread_ref?.id && schedule.days_of_week.includes(dayOfWeek)
          ) ?? preorderSchedules.find((schedule) => schedule.bread_ref.id === bread.bread_ref?.id)
        const dailyStocks = stocks.filter(
          (stock) => stock.type === 'daily' && stock.bread_ref.id === bread.bread_ref?.id
        )
        const preorderStocks = stocks.filter(
          (stock) => stock.type === 'preorder' && stock.bread_ref.id === bread.bread_ref?.id
        )
        const dailyCheckoutItems = checkoutItems.filter((checkoutItem) => {
          return checkoutItem.bread_ref.id === bread.bread_ref?.id && checkoutItem.type === 'daily'
        })
        const preorderCheckoutItems = checkoutItems.filter((checkoutItem) => {
          return checkoutItem.bread_ref.id === bread.bread_ref?.id && checkoutItem.type === 'preorder'
        })
        return (
          <Fragment key={bread.bread_ref.id}>
            {index !== 0 && <HorizontalLine verticalMargin={16} />}
            <ScheduledItemCard
              bread={bread}
              categoryName={category.name}
              checkedOrderTypes={checkedOrderTypes}
              currentTab={currentTab}
              date={date}
              dayOfWeek={dayOfWeek}
              isAfterLastOrder={isAfterLastOrder}
              isFuture={isFuture}
              isTemporaryClose={isTemporaryClose}
              dailyStocks={dailyStocks}
              preorderStocks={preorderStocks}
              dailySchedule={dailySchedule}
              preorderSchedule={preorderSchedule}
              dailyCheckoutItems={dailyCheckoutItems}
              preorderCheckoutItems={preorderCheckoutItems}
            />
          </Fragment>
        )
      })}
    </Card>
  )
}

export default ScheduledItemCardList
